// @ts-nocheck
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { GLOBAL_CONSTANT } from '../../../../contants/global.const';
import { SEND_SERVICE } from '../../../../services/send.service';
import { Logger } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class NoteBackend {
  private sendService = inject(SEND_SERVICE);
  private logger = inject(Logger);
  readonly Global = inject(GLOBAL_CONSTANT);

  getNotesByProcessId<T>(params): Observable<T> {
    try {
      const url = this.Global.services.note.getNotesByProcessId();
      return this.sendService.get(url, { params });
    } catch (error) {
      this.logger.error(error);
      throw error;
    }
  }
  getNotesByContext<T>(params): Observable<T> {
    try {
      const url = this.Global.services.note.getNotesByContext();
      return this.sendService.get(url, { params });
    } catch (error) {
      this.logger.error(error);
      throw error;
    }
  }

  getHistoricFileById<T>(params): Observable<T> {
    try {
      const url = this.Global.services.audience.getHistoricFileById();
      return this.sendService.get(url, { params });
    } catch (error) {
      this.logger.error(error);
      throw error;
    }
  }

  getHistoricCourtHearing<T>(params): Observable<T> {
    try {
      const url = this.Global.services.audience.getHistoricCourtHearing();
      return this.sendService.get(url, { params });
    } catch (error) {
      this.logger.error(error);
      throw error;
    }
  }

  getNotesByTaskId<T>(params): Observable<T> {
    try {
      const url = this.Global.services.note.getNotesByTaskId();
      return this.sendService.get(url, { params });
    } catch (error) {
      this.logger.error(error);
      throw error;
    }
  }

  sendNotes<T>(body): Observable<T> {
    try {
      const url = this.Global.services.note.note();
      return this.sendService.post(url, body, {});
    } catch (error) {
      this.logger.error(error);
      throw error;
    }
  }

  upNotes<T>(body, id): Observable<T> {
    try {
      const params = { id };
      const url = this.Global.services.note.note();
      return this.sendService.put(url, body, { params });
    } catch (error) {
      this.logger.error(error);
      throw error;
    }
  }
}
